import React from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import GermanyMapPage from "../pages/GermanyMap/GermanyMapPage";

const AppRoutes = () => {
  return (
    <Routes>
      {/* Single page route */}
      <Route path="/" element={<GermanyMapPage />} />

      {/* Redirect to dashboard if no route matches */}
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
};

export default AppRoutes;
